import { render, staticRenderFns } from "./transactionBox.vue?vue&type=template&id=a53056ae&scoped=true"
import script from "./transactionBox.vue?vue&type=script&lang=js"
export * from "./transactionBox.vue?vue&type=script&lang=js"
import style0 from "./transactionBox.vue?vue&type=style&index=0&id=a53056ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53056ae",
  null
  
)

export default component.exports